var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.display_contract)?_c('DashboardFirstLogin'):_c('DashboardDefault')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }